import { SharedAngular } from '@Client/@types/sharedAngular';
import IProcedureDetail from '@Shared.Angular/@types/core/contracts/queryModel/procedure/procedureDetail';
import angular from 'angular';
import { IStateParamsService, IStateService } from 'angular-ui-router';

class ProcedureController {
  static $inject = ['procedure', 'APP_CONFIG', '$state', '$stateParams'];
  private readOnly: boolean;
  private backLinkState: string;

  constructor(
    private procedure: IProcedureDetail,
    private APP_CONFIG: SharedAngular.APP_CONFIG,
    private $state: IStateService,
    private $stateParams: IStateParamsService
  ) {
    if (!APP_CONFIG.enableProcedures) {
      $state.go('app.runner.flowsactive');
    }
    this.readOnly = $stateParams.edit !== 'true';
    this.backLinkState = this.readOnly
      ? 'app.runner.procedures'
      : 'app.runner.library.procedures';
  }
}

angular
  .module('flowingly.runner.procedures')
  .controller('procedureController', ProcedureController);
